"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

var _Note = require("./Note");

var _Note2 = _interopRequireDefault(_Note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotesModel = function (_Observer) {
    _inherits(NotesModel, _Observer);

    function NotesModel(observers, id, request) {
        _classCallCheck(this, NotesModel);

        var _this = _possibleConstructorReturn(this, (NotesModel.__proto__ || Object.getPrototypeOf(NotesModel)).call(this, observers, id, request));

        _this.Note = new _Note2.default();
        _this.Notes = [];
        return _this;
    }
    /**
     * Liste von Bemerkungen
     * @type {array}
     */


    _createClass(NotesModel, [{
        key: "GetNotes",
        value: function GetNotes() {
            if (searchString !== null && searchString !== undefined && ticketStart !== null && ticketStart !== undefined) {
                var me = this;
                this.request.setRequest("/Notes");
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.Notes = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "Notes";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: "GetNotesByCustomerId",
        value: function GetNotesByCustomerId(customertId) {
            var me = this;

            this.request.setRequest("/customers/" + customertId + "/notes");
            this.request.setType("GET");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.Notes = data.Data;
                    }
                }
                var id = me.Id ? me.Id : "NotesByCustomerId";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "InsertNote",
        value: function InsertNote(customerId, text, date) {
            var me = this;

            me.Note.CustomerId = customerId;
            me.Note.Text = text;
            me.Note.Date = date;

            this.request.setRequest("/notes");
            this.request.setData(JSON.stringify(me.Note));
            this.request.setType("POST");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.Notes = date.Data;
                    }
                }
                var id = me.Id ? me.Id : "InsertNote";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return NotesModel;
}(_Observer3.default);

exports.default = NotesModel;